// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export const InstrumentTypes = 
{
    //внутренние типы
    ALL: -100,
    INS_HISTORY: -99,
    GENERAL: 0,
    // эти типы инструментов совпадают с серверными
    FOREX: 1,
    EQUITIES: 2,
    FUTURES: 3,
    OPTIONS: 4,
    EQUITIES_CFD: 5,
    FORWARD: 6,
    CFD_FUTURES: 7,
    INDICIES: 8,
    PORTFOLIO: 9,
    CRYPTO: 10,
    SPREADBET: 11,
    BOND: 12,
    ETF: 13, // Exchange traded fund
    TBILL: 14,
    SPOT: 15,
    CORPORATE: 16
};

Object.freeze(InstrumentTypes);